/**
 * Clones the hidden benefits source template (rebuy-flyout-benefits-source.liquid)
 * into the Rebuy cart flyout footer, below the checkout button.
 */
(function () {
  var FOOTER_SELECTOR = '.rebuy-cart__flyout-footer';
  var CHECKOUT_BTN_SELECTOR = '.rebuy-button.rebuy-cart__checkout-button.block';
  var SOURCE_SELECTOR = '#rebuy-flyout-benefits-source';
  var INJECTED_MARKER = 'data-rebuy-flyout-benefits-injected';

  function inject() {
    var footer = document.querySelector(FOOTER_SELECTOR);
    if (!footer || footer.hasAttribute(INJECTED_MARKER)) return !!footer;

    var source = document.querySelector(SOURCE_SELECTOR);
    var anchor = footer.querySelector(CHECKOUT_BTN_SELECTOR);
    if (!source || !anchor) return false;

    var clone = source.firstElementChild ? source.firstElementChild.cloneNode(true) : null;
    if (!clone) return false;

    anchor.insertAdjacentElement('afterend', clone);
    footer.setAttribute(INJECTED_MARKER, '');
    return true;
  }

  function run() {
    if (inject()) return;
    var t = setInterval(function () {
      if (inject()) clearInterval(t);
    }, 300);
    setTimeout(function () { clearInterval(t); }, 15000);
  }

  function observe() {
    run();
    var observer = new MutationObserver(function () {
      if (document.querySelector(FOOTER_SELECTOR)) run();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  document.addEventListener('rebuy:cart.change', run);
  document.addEventListener('rebuy.cart.change', run);
})();
